/*
* Pipeline Theme — Custom JS
*/

(function() {

  // ===== Sticky ATC Bar =====
  (function initStickyATC() {
    var bar = document.getElementById('sticky-atc-bar');
    var trigger = document.getElementById('sticky-atc-trigger');
    var nativeBtn = document.querySelector('[data-native-atc]');
    var stickyMeta = document.getElementById('sticky-atc-meta');
    var stickyPrice = document.getElementById('sticky-atc-price');
    var stickyBtnText = document.getElementById('sticky-atc-btn-text');

    if (!bar || !nativeBtn) return;

    function updateBarVisibility() {
      var rect = nativeBtn.getBoundingClientRect();
      var belowFold = rect.bottom < 0;
      var aboveFold = rect.top > window.innerHeight;
      if (belowFold || aboveFold) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    function updateStickyMeta(variant) {
      if (!stickyMeta) return;
      var parts = [];
      if (variant && variant.title && variant.title !== 'Default Title') {
        parts = variant.title.split(' / ');
      }
      stickyMeta.textContent = parts.join(' · ');
    }

    function updateStickyPrice(price) {
      if (!stickyPrice) return;
      stickyPrice.textContent = Shopify && Shopify.formatMoney
        ? Shopify.formatMoney(price, '{{ amount }}')
        : '$' + (price / 100).toFixed(2);
    }

    if (trigger) {
      trigger.addEventListener('click', function() {
        var realBtn = document.querySelector('[data-add-to-cart]');
        if (realBtn && !realBtn.disabled) {
          realBtn.click();
        }
      });
    }

    document.addEventListener('theme:variant:change', function(event) {
      var variant = event.detail.variant;
      if (!variant) return;
      updateStickyMeta(variant);
      updateStickyPrice(variant.price);

      if (stickyBtnText) {
        if (!variant.available) {
          stickyBtnText.textContent = 'Sold Out';
          trigger.disabled = true;
        } else {
          stickyBtnText.textContent = 'Add to Cart';
          trigger.disabled = false;
        }
      }
    });

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateBarVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    updateBarVisibility();
  })();


  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
  });

  document.addEventListener('theme:cart:init', (e) => {});
  document.addEventListener('theme:scroll', e => {});
  document.addEventListener('theme:resize', e => {});

})();


// ===== OLEN Carriers external link: open in a new tab =====
// Keeps visitors on roobearkids.com when they click the OLEN Carriers menu link.
(function() {
  function markOlenLinks() {
    var links = document.querySelectorAll('a[href*="olencarry.com"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('target', '_blank');
      links[i].setAttribute('rel', 'noopener noreferrer');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markOlenLinks);
  } else {
    markOlenLinks();
  }
  document.addEventListener('shopify:section:load', markOlenLinks);
})();
